import { Seo } from "@/components/Seo";
import AuthorFollow from "@/components/site/AuthorFollow";
import GalleryPage from "@/pages/GalleryPage";

export default function BooksPage() {
  return (
    <>
      <Seo
        title="Books by Dr. Dennis Louden — Delta DL Enterprise, LLC"
        description="Published books by Dr. Dennis Louden — practical knowledge, real-world experience, and personal transformation."
        path="/books"
      />
      <GalleryPage
        only="books"
      overline="The Library"
      heading="Books"
      subtitle="Published books by Dr. Dennis Louden — practical knowledge, real-world experience, and personal transformation."
      note="To order a book, tap any cover to see its details and request it — we'll confirm your order personally by email. Questions about titles, bulk orders, or signed copies welcome:"
    />
      <div className="border-t border-white/10 bg-[#050505] px-6 md:px-12 pb-24">
        <div className="mx-auto max-w-[1400px]">
          <AuthorFollow />
        </div>
      </div>
    </>
  );
}
